import { render } from "./ReferralBonus.vue?vue&type=template&id=1c03b833&scoped=true"
import script from "./ReferralBonus.vue?vue&type=script&lang=js"
export * from "./ReferralBonus.vue?vue&type=script&lang=js"

import "./ReferralBonus.vue?vue&type=style&index=0&id=1c03b833&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c03b833"]])

export default __exports__